// extracted by mini-css-extract-plugin
export default {"Item_Card":"estilo_Item_Card__SoKe5"};